import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Reset } from "styled-reset"
import { ThemeProvider } from "styled-components"
import GlobalStyle from "../style/global-styles"
import { theme } from "../style/theme"
import Header from "./header"
import Footer from "./footer"

export default function Layout({ children, setShowDiolog, setDiologOrigin }) {
    const data = useStaticQuery(graphql`
        query {
            allMarkdownRemark(
                filter: { frontmatter: { title: { eq: "menu" } } }
            ) {
                edges {
                    node {
                        frontmatter {
                            image
                            title
                            contact_information {
                                name
                                address
                                address_2
                                city
                                state
                                postal_code
                                phone
                            }
                            links {
                                name
                                url
                                section
                                image
                            }
                            section_headings
                            social_media_links {
                                name
                                url
                                icon
                            }
                        }
                    }
                }
            }
            allImageSharp {
                edges {
                    node {
                        fixed {
                            aspectRatio
                            src
                            srcSet
                            originalName
                        }
                        fluid {
                            src
                            srcSet
                            originalImg
                            originalName
                        }
                    }
                }
            }
        }
    `)
    const menuData = data.allMarkdownRemark.edges[0].node.frontmatter
    const allImages = data.allImageSharp.edges
    const images = {}

    allImages.forEach(el => {
        images["/content/images/" + el.node.fluid.originalName] = el.node
    })

    return (
        <ThemeProvider theme={theme}>
            <Reset />
            <GlobalStyle />
            <Header
                data={menuData}
                images={images}
                setShowDiolog={setShowDiolog}
                setDiologOrigin={setDiologOrigin}
            />
            {children}
            <Footer data={menuData} />
        </ThemeProvider>
    )
}
